import * as z from 'zod';

import type { CreateSchemaTypes } from '../createZodSchema';

export function checkboxValidator(field: CreateSchemaTypes) {
  const validator = z.boolean();

  return field.required ? validator.refine(Boolean, 'Dit veld is verplicht') : validator.optional();
}
